import { AfterViewInit, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'ui-toggle',
  templateUrl: './ui-toggle.component.html',
  styleUrls: ['./ui-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiToggleComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [FormsModule],
})
export class UiToggleComponent implements ControlValueAccessor, AfterViewInit {
  @Input()
  public value = false;
  @Input()
  public disabled = false;

  public initDone = false;

  public registerOnChange(fn: () => unknown): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => unknown): void {
    this.onTouched = fn;
  }

  public writeValue(val: boolean): void {
    this.value = val;
  }

  public toggle(): void {
    this.value = !this.value;
    this.onChange(this.value);
    this.onTouched();
  }

  public onChange: (val: boolean) => void = () => undefined;
  public onTouched: () => void = () => undefined;

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.initDone = true;
    });
  }
}
